

import {Component, Vue} from 'vue-property-decorator';
import user_module from '@/modules/user/index';



@Component
export default class Trial extends Vue {

  get product(){

    let productId = this.$route.query.product;

    if (typeof productId === 'string'){

      productId = productId.toUpperCase();
    }
    
    const product = user_module.userProducts.find(product => product.productCode === productId);

    if (product){

      return product.name;
    }


    return '';
  }

}

